import React__default from 'react';
import { applyTheme } from '../Theme/Theme.js';
import classNames from 'classnames';

const Loader = (props) => {
    const { isLoading, theme, transparent = true } = props;
    if (!isLoading)
        return null;
    const classNames$1 = classNames('xps-page-loader-wrapper', { 'xps-page-loader-wrapper--transparent': transparent }, applyTheme(theme));
    return (React__default.createElement("div", { className: classNames$1 },
        React__default.createElement("svg", { className: 'xps-page-loader-spinner', viewBox: '0 0 50 50' },
            React__default.createElement("circle", { stroke: 'currentColor', className: 'path', cx: '25', cy: '25', r: '20', fill: 'none', strokeWidth: '2' }))));
};
const PlainLoader = (props) => {
    const { transparent = true, theme } = props;
    const classNames$1 = classNames('xps-page-loader-wrapper', { 'xps-page-loader-wrapper--transparent': transparent }, applyTheme(theme));
    return (React__default.createElement("div", { className: classNames$1 },
        React__default.createElement("svg", { className: 'xps-page-loader-spinner', viewBox: '0 0 50 50' },
            React__default.createElement("circle", { stroke: 'currentColor', className: 'path', cx: '25', cy: '25', r: '20', fill: 'none', strokeWidth: '2' }))));
};

export { Loader, PlainLoader, Loader as default };
//# sourceMappingURL=Loader.js.map
